"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyObject = exports.stringifyQuery = exports.parseObjectFromString = exports.parseQuery = void 0;
var query_string_1 = __importDefault(require("query-string"));
function parseQuery(query) {
    return parseObjectFromString('q', query);
}
exports.parseQuery = parseQuery;
function parseObjectFromString(name, objectString) {
    if (!objectString)
        return {};
    var parsedQuery = query_string_1.default.parse(objectString);
    var checkValue = parsedQuery[name];
    if (typeof checkValue === 'string')
        return JSON.parse(checkValue);
    return {};
}
exports.parseObjectFromString = parseObjectFromString;
function stringifyQuery(query) {
    return stringifyObject(query, 'q');
}
exports.stringifyQuery = stringifyQuery;
function stringifyObject(object, name) {
    var _a;
    return query_string_1.default.stringify((_a = {}, _a[name] = JSON.stringify(object), _a));
}
exports.stringifyObject = stringifyObject;
//# sourceMappingURL=spec.js.map